/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { AiCoach_Action } from '__generated__/graphql-types';

import { SparkleIcon } from 'bundles/ai-course-coach/assets/mui';
import { CoachButton } from 'bundles/ai-course-coach/components/common';
import { useNewFeatureStyles } from 'bundles/ai-course-coach/utils/newFeaturesUtils';

import _t from 'i18n!nls/learning-assistant-chat-ai';

import type { Props as CoachButtonProps } from './CoachButton';

type Props = { children: string } & CoachButtonProps;

/**
 * Simple wrapper around CoachButton for recap.
 */
export const CoachRecapButton = (props: Props): React.ReactElement => {
  const { children, onClick, ...rest } = props;

  const { newFeatureCSS, newFeatureInteractedCallback } = useNewFeatureStyles({
    feature: AiCoach_Action.Recap,
  });

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);

    newFeatureInteractedCallback();
  };

  return (
    <CoachButton
      variant="secondary"
      size="small"
      aria-label={_t('#{label}, #{coachLabel} trigger', { label: children, coachLabel: 'Coach' })}
      icon={<SparkleIcon />}
      iconPosition="before"
      onClick={handleClick}
      css={newFeatureCSS}
      {...rest}
    >
      {children}
    </CoachButton>
  );
};

export default CoachRecapButton;
